import { render, staticRenderFns } from "./printGroups.vue?vue&type=template&id=cec843ca"
import script from "./printGroups.vue?vue&type=script&lang=ts"
export * from "./printGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports